import { render, staticRenderFns } from "./ApfAfterSaveDraftMessage.vue?vue&type=template&id=ef57c9e6"
import script from "./ApfAfterSaveDraftMessage.vue?vue&type=script&lang=js"
export * from "./ApfAfterSaveDraftMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports